import React from "react";
import Page from "../../components/page";
import Select from "react-select";
import Dialog from "../../components/dialog";
import Overlay from "../../components/overlay";

export default function() {
  const {
    updateSuccess,
    loading,
    machine = {
      serial_number: "",
      code: "",
      machine_hours: "",
      test_date: "",
      hire_status: ""
    },
    errMsg
  } = this.state;
  const { history } = this.props;

  return (
    <Page header="Update Machine">
      <div className="update-list">
        <label>Serial number</label>
        <input
          value={machine.serial_number}
          onChange={event =>
            this._updateMachine({ serial_number: event.target.value })
          }
        />
        <label>Machine code</label>
        <input
          value={machine.code}
          onChange={event => this._updateMachine({ code: event.target.value })}
        />
        <label>Machine hours</label>
        <input
          value={machine.machine_hours}
          type="number"
          onChange={event =>
            this._updateMachine({ machine_hours: event.target.value })
          }
        />
        <label>Test and tag date</label>
        <input defaultValue={machine.test_date} disabled type="date" />

        <label>Machine status</label>
        <Select
          onChange={({ label, value }) =>
            this._updateMachine({ hire_status: value })
          }
          value={{ value: machine.hire_status, label: machine.hire_status }}
          options={[
            { value: "Available", label: "Available" },
            { value: "Unavailable", label: "Unavailable" }
          ]}
        />
      </div>
      {loading && <Overlay />}
      <div className="button-group">
        <button onClick={() => history.goBack()}>Cancel</button>
        <button onClick={this._submit}>Confirm</button>
      </div>

      {errMsg && (
        <div>
          <h3 className="update-errMsg">{errMsg}</h3>
        </div>
      )}

      {updateSuccess && (
        <Dialog close={() => this.setState({ updateSuccess: false })}>
          <span className="dialog-span">Machine has been updated</span>

          <button
            onClick={() => {
              this.setState({ updateSuccess: false });
              history.replace("/machine");
            }}
          >
            Ok
          </button>
        </Dialog>
      )}
    </Page>
  );
}



// WEBPACK FOOTER //
// ./src/screens/update/view.js